import { Box, Modal } from "@mui/material";
import type React from "react";

type Props = {
	isOpen: boolean;
	onClose?: () => void;
	children: React.ReactNode;
};

const ModalCard: React.FC<Props> = ({ isOpen, onClose, children }) => {
	return (
		<Modal
			open={isOpen}
			onClose={onClose}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box className="w-full h-dvh pt-14">
				<Box className="wrapper w-full h-full bg-white overflow-y-auto scroll-hidden rounded-t-2xl px-4 pt-4 pb-[72px] mb-20">
					{children}
				</Box>
			</Box>
		</Modal>
	);
};

export default ModalCard;
